/** @module Specification/SizeMap/SizeMapTable */
define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/xml",
	"../SizeVariationTable"
], function(declare,locale,xml,SizeVariationTable) {

	var SIZEMAP_PARAMS = {
		aggregation: "TargetSizes",
		attrType: xml.ATTR_REF,
		attr: "SourceSize",
		composition: "SizeMapSizes",
		nodeType: "SizeMapSize",
		operation: "SizeMapSetSizeMapSizes"
	};
	
	return declare(SizeVariationTable, {
		bomSizeVariation: SIZEMAP_PARAMS,

		/**
		 * @override
		 * Change the test to enable the "Save" button since we are applying changes to the client nodes 
		 */
		canEnableButton: function(button, idAction) {
			return this.inherited(arguments) || this._bValueChanged;
		},

		/**
		 * @override
		 * Initialize column names
		 */
		onResolveSizes: function() {
			this.set("column1Name", locale.resource("TargetSize"));
			this.set("column2Name", locale.typeId("SizeMapSize", "SourceSize"));
		}
	});
});